import React from 'react';

const OrderTableFilters = ({ value, onChange, onClear }) => {
  const handleChange = (e) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: v });
  };
  return (
    <fieldset className='filters-bar'>
      <legend className='visually-hidden'>Filters</legend>
      <div className='row g-2'>
        <div className='col-6 col-md-2'>
          <input name='id' value={value.id} onChange={handleChange} placeholder='Order ID' className='form-control form-control-sm' />
        </div>
        <div className='col-6 col-md-2'>
          <input name='user' value={value.user} onChange={handleChange} placeholder='Username' className='form-control form-control-sm' />
        </div>
        <div className='col-6 col-md-2'>
          <input type='date' name='dateFrom' value={value.dateFrom} onChange={handleChange} className='form-control form-control-sm' />
        </div>
        <div className='col-6 col-md-2'>
          <input type='date' name='dateTo' value={value.dateTo} onChange={handleChange} className='form-control form-control-sm' />
        </div>
        <div className='col-6 col-md-2'>
          <input name='totalMin' value={value.totalMin} onChange={handleChange} placeholder='Min Total' className='form-control form-control-sm' />
        </div>
        <div className='col-6 col-md-2'>
          <input name='totalMax' value={value.totalMax} onChange={handleChange} placeholder='Max Total' className='form-control form-control-sm' />
        </div>
        <div className='col-6 col-md-2'>
          <select name='paid' value={value.paid} onChange={handleChange} className='form-select form-select-sm'>
            <option value=''>Paid?</option>
            <option value='yes'>Yes</option>
            <option value='no'>No</option>
          </select>
        </div>
        <div className='col-6 col-md-2'>
          <select name='shipped' value={value.shipped} onChange={handleChange} className='form-select form-select-sm'>
            <option value=''>Shipped?</option>
            <option value='yes'>Yes</option>
            <option value='no'>No</option>
          </select>
        </div>
        <div className='col-6 col-md-2'>
          <select name='delivered' value={value.delivered} onChange={handleChange} className='form-select form-select-sm'>
            <option value=''>Delivered?</option>
            <option value='yes'>Yes</option>
            <option value='no'>No</option>
          </select>
        </div>
        <div className='col-6 col-md-2'>
          <select name='refundPending' value={value.refundPending} onChange={handleChange} className='form-select form-select-sm'>
            <option value=''>Refund Pending?</option>
            <option value='yes'>Yes</option>
            <option value='no'>No</option>
          </select>
        </div>
        <div className='col-6 col-md-2'>
          <select name='refundDenied' value={value.refundDenied} onChange={handleChange} className='form-select form-select-sm'>
            <option value=''>Refund Denied?</option>
            <option value='yes'>Yes</option>
            <option value='no'>No</option>
          </select>
        </div>
        <div className='col-12 col-md-2 mt-2 mt-md-0'>
          <button type='button' onClick={onClear} className='btn btn-outline-secondary btn-sm w-100'>Clear All</button>
        </div>
      </div>
    </fieldset>
  );
};

export default OrderTableFilters;
